import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

export interface ISetting {
  id: number
  system_and_defense_custom_url?: string
}

class Setting extends Model<ISetting> {
  static urlRoot() {
    return '/complaints/settings'
  }

  constructor(attr: ISetting) {
    super(attr)

    makeObservable(this, {
      id: computed,
      system_and_defense_custom_url: computed,
    })
  }

  get id(): number {
    return this.attributes.id
  }

  get system_and_defense_custom_url(): string | undefined {
    return this.attributes.system_and_defense_custom_url
  }
}

export default Setting
